import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type RenameFormArgs = {
	name: string;
};

/** `180` mirrors the server constraint on the name. */
@ValidatedClass()
class RenameFormData extends AbstractValidatedClass<RenameFormArgs> {
	@constraint(Joi.string().trim().required().max(180), () => 'Le nom est obligatoire.')
	public readonly name: string;

	constructor(data: RenameFormArgs) {
		super(data);
		this.name = data.name;
		Object.freeze(this);
	}

	static fromName(name: string): RenameFormData {
		return new RenameFormData({ name });
	}

	setName(name: string): this {
		return this.cloneWith({ name } as Partial<RenameFormArgs>);
	}
}

export default RenameFormData;
